import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getMessageImgPreview = async ({ questionNoteId, fileName }) => {
  return await request.get(
    `/Question/note_preview`,
    { questionNoteId, fileName },
    'При загрузке превью изображения для сообщения произошла ошибка',
    ''
  );
};

const useMessageImgPreview = ({ id, questionNoteId, fileName }, options) =>
  useQuery(
    questionsQueryKeys.messageImgPreview(id),
    () => getMessageImgPreview({ questionNoteId, fileName }),
    options
  );

export default useMessageImgPreview;
